var _rect, _path, _ellipse, _line, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 56,
    height: 43,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.333C16 26.2284 16.8954 25.333 18 25.333H20.7639C21.5215 25.333 22.214 24.905 22.5528 24.2274L23.4472 22.4386C23.786 21.761 24.4785 21.333 25.2361 21.333H30.7639C31.5215 21.333 32.214 21.761 32.5528 22.4386L33.4472 24.2274C33.786 24.905 34.4785 25.333 35.2361 25.333H38C39.1046 25.333 40 26.2284 40 27.333V40.6663C40 41.7709 39.1046 42.6663 38 42.6663H18C16.8954 42.6663 16 41.7709 16 40.6663V27.333Z",
    fill: "#407DFF",
    stroke: "#407DFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0003,
    cy: 33.3333,
    rx: 5.33333,
    ry: 5.33333,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 15.25,
    x2: 56,
    y2: 15.25,
    stroke: "#1E1F22",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10.5,
    r: 1.5,
    fill: "#1E1F22"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 1.5,
    fill: "#1E1F22"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 10.5,
    r: 1.5,
    fill: "#1E1F22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.a5f4790539cfeb65320b3d316a531652.svg";
export { ForwardRef as ReactComponent };